/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, Directive, ElementRef, Input, OnInit} from '@angular/core';
import {Studio} from "../../models/Studio";

/**
 * Generated class for the StudioIcon component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Directive({
  selector: 'studio-icon',
})
export class StudioIcon {

  private alphabetColors: Array<string> = [
    "#f44336",
    "#2196f3",
    "#ffeb3b",
    "#9c27b0",
    "#4caf50",
    "#ff9800",
    "#00bcd4",
    "#e91e63",
    "#673ab7",
    "#009688",
    "#aa00ff",
    "#AD1457",
    "#1976d2",
    "#fbc02d",
    "#7b1fa2",
    "#388e3c",
    "#651fff",
    "#ce93d8",
    "#a5d6a7",
    "#ffcc80",
    "#80deea",
    "#f48fb1",
    "#90caf9",
    "#fff59d",
    "#b39ddb",
    "#80cbc4"];

  private _studio: Studio;


  @Input()
  set studio(s: Studio) {
    this._studio = s;
    if (s) {
      this.generateColor();
    }
  };

  @Input()
  useIndicator: boolean = true;

  constructor(private element: ElementRef) {

  }

  private generateColor() {
    let colorIdx: number = 0;

    if (!this._studio || !this._studio.identifier) {
      console.log('Studio identifer is missing');
      console.log(this._studio);
    } else if (this.useIndicator) {
      colorIdx = Math.floor(this._studio.identifier.charCodeAt(0) - 65) % this.alphabetColors.length;
    }

    this.element.nativeElement.style.backgroundColor = this.alphabetColors[colorIdx];

    if (this._studio.identifier) {
      this.element.nativeElement.setAttribute('value', this._studio.identifier);
    }

    // this.settings.color = this.alphabetColors[colorIdx];
  }

}



// WEBPACK FOOTER //
// ./src/components/studio-icon/studio-icon.ts